import React from 'react';
import { Button, Card, TextField, Typography, styled } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { apipost } from '../../service/api'; // Make sure this path is correct

const SectionCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(5),
  boxShadow: theme.shadows[3],
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const ContactForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

const validationSchema = yup.object({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  emailAddress: yup.string().email('Invalid email').required("Email is required"),
  message: yup.string().required('Message is required'),
});

function ContactUsForm() {
    const formik = useFormik({
      initialValues: {
        title: 'Mr.',
        firstName: '', // This represents the lead's first name
        lastName: '', // This represents the lead's last name
        email: '',
        message: '',
        // Define the assignedAgent object with its default values
        assignedAgent: {
          firstName: "admin",
          lastName: "admin",
          _id: "64d5bd3aca0be228afc9e267",
        },
      },
    // validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        // Directly use values for firstName, lastName, and email
        const payload = {
          ...values, // Spread operator to include all form values directly
          emailAddress: values.email, // Map `email` field to `emailAddress` in your payload if necessary
        };
        
        const response = await apipost('lead/add', payload);
        if (response.status === 201) {
          toast.success('Your message has been sent successfully!');
          resetForm();
        } else {
          toast.error('There was an issue submitting your message. Please try again.');
        }
      } catch (error) {
        toast.error('There was an issue submitting your message. Please try again.');
        console.error('Error submitting contact form:', error);
      }
    },
  });

  return (
    <SectionCard>
      <Typography variant="h5" gutterBottom>
        Get in Touch
      </Typography>
      <ContactForm onSubmit={formik.handleSubmit} noValidate autoComplete="off">
        <TextField
          required
          id="firstName"
          name="firstName"
          label="First Name"
          variant="outlined"
          fullWidth
          value={formik.values.firstName}
          onChange={formik.handleChange}
          error={formik.touched.firstName && Boolean(formik.errors.firstName)}
          helperText={formik.touched.firstName && formik.errors.firstName}
        />
        <TextField
          required
          id="lastName"
          name="lastName"
          label="Last Name"
          variant="outlined"
          fullWidth
          value={formik.values.lastName}
          onChange={formik.handleChange}
          error={formik.touched.lastName && Boolean(formik.errors.lastName)}
          helperText={formik.touched.lastName && formik.errors.lastName}
        />
        <TextField
          required
          id="email"
          name="email"
          label="Email"
          type="email"
          variant="outlined"
          fullWidth
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />
        <TextField
          required
          id="message"
          name="message"
          label="Message"
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={formik.values.message}
          onChange={formik.handleChange}
          error={formik.touched.message && Boolean(formik.errors.message)}
          helperText={formik.touched.message && formik.errors.message}
        />
        <StyledButton type="submit" variant="contained">
          Submit
        </StyledButton>
      </ContactForm>
    </SectionCard>
  );
}

export default ContactUsForm;
